import { render, staticRenderFns } from "./ScreeningFindingsPreferences.vue?vue&type=template&id=e02b1e3c&"
import script from "./ScreeningFindingsPreferences.vue?vue&type=script&lang=js&"
export * from "./ScreeningFindingsPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports